// App.tsx
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from './components/theme-provider'
import Layout from './components/layout/Layout'
import Dashboard from './pages/Dashboard'
import Login from './pages/Login'
import NotFound from './pages/NotFound'
import ProtectedRoute from './components/ProtectedRoute'
import RoleProtectedRoute from './components/RoleProtectedRoute'
import { useEffect } from 'react'
import { initializeAuth } from './store/authStore'
import PublicMenuPage from './pages/public/PublicMenuPage';
import PublicMenuPageDark from './pages/public/PublicMenuPageDark';
import PublicMenuPageLight from './pages/public/PublicMenuPageLight';
import PublicMenuPageDarkComplex from './pages/public/PublicMenuPageDarkComplex';
import PublicMenuPageLightComplex from './pages/public/PublicMenuPageLightComplex';
import TestBackground from './components/TestBackground';
import PrivacyPolicy from './pages/public/privacy-policy';
import Conditions from './pages/public/conditions';

// Menu Related Pages
import CreateMenuPage from './pages/menus/CreateMenu'
import CreateMenuWizard from './pages/menus/CreateMenuWizard'
import MenuListPage from "./pages/menus/ListingMenu"
import MenuDetailPage from './pages/menus/MenuDetailPage'
import AIImportMenu from './pages/menus/AIImportMenu'

// Allergen Management
import AllergenListPage from './pages/allergens/AllergenListPage'
import AllergenFormPage from './pages/allergens/AllergenFormPage'

// User Management
import UserManagement from './pages/users/UserManagement'
import CreateUser from './pages/users/CreateUser'
import EditUser from './pages/users/EditUser'

import PdfViewPage from './pages/public/PdfViewPage'
import PdfGenerator from './pages/menus/PdfGenerator'

import WhatsAppSettings from './pages/WhatsAppManager'
import { ToastContainer } from './components/common/ToastNotification'

function App() {
  useEffect(() => {
    initializeAuth();
  }, []);

  return (
    <ThemeProvider defaultTheme="light" storageKey="menu-digitale-theme">
      <Router>
        <ToastContainer />
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/menu/:slug" element={<PublicMenuPage />} />
          <Route path="/menu-dark/:slug" element={<PublicMenuPageDark />} />
          <Route path="/menu-light/:slug" element={<PublicMenuPageLight />} />
           <Route path="/menu-darkComplex/:slug" element={<PublicMenuPageDarkComplex />} />
          <Route path="/menu-lightComplex/:slug" element={<PublicMenuPageLightComplex />} />
          <Route path="/menu/:menuId/pdf/:pdfId" element={<PdfViewPage />} />
           <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<Conditions />} />



          
          {/* PDF Viewing Route - Public access */}
          <Route path="/pdf-view/:pdfId" element={<PdfViewPage />} />
          
          {/* Protected Routes (requires authentication) */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Layout />}>
              {/* Dashboard - accessible to all authenticated users */}
              <Route index element={<Dashboard />} />
              
              {/* Menu Management Routes - accessible to all authenticated users */}
              <Route path="menus">
                <Route index element={<MenuListPage />} />
                <Route path="create" element={<CreateMenuWizard />} />
                <Route path=":menuId" element={<MenuDetailPage />} />
                <Route path=":menuId/pdf-generator" element={<PdfGenerator />} />
                <Route path=":menuId/ai-import" element={<AIImportMenu />} />
              </Route>
              
              {/* Allergen Management Routes - accessible to all authenticated users */}
              <Route path="allergens">
                <Route index element={<AllergenListPage />} />
                <Route path="create" element={<AllergenFormPage />} />
                <Route path=":allergenId/edit" element={<AllergenFormPage />} />
              </Route>
              
              {/* User Management Routes - Only accessible to admin users, exclude restaurant-owner */}
              <Route element={
                <RoleProtectedRoute 
                  allowedRoles={['admin', 'super-admin', 'agency']} 
                  excludedRoles={['restaurant-owner']}
                  redirectTo="/"
                />
              }>
                <Route path="users">
                  <Route index element={<UserManagement />} />
                  <Route path="create" element={<CreateUser />} />
                  <Route path=":id/edit" element={<EditUser />} />
                </Route>
              </Route>
                <Route element={
                  <RoleProtectedRoute 
                    allowedRoles={['admin', 'super-admin', 'restaurant-owner', 'agency']}
                    redirectTo="/"
                  />
                }>
                  <Route path="whatsapp" element={<WhatsAppSettings />} />
                </Route>
                
              
              {/* You can also use just excludedRoles to block specific roles */}
              {/* Example: Block restaurant-owner from some other route */}
              {/* <Route element={<RoleProtectedRoute excludedRoles={['restaurant-owner']} />}>
                <Route path="some-restricted-route" element={<SomeComponent />} />
              </Route> */}
            </Route>
          </Route>
          

        
          {/* Catch all route - 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </ThemeProvider>
  )
}

export default App